import ko from "knockout";
import $ from "jquery";
import register from "flow/knockout/register";

register.registerKnockoutBinding("fade", {
    init: function (element, valueAccessor) {
        // Initially set the element to be instantly visible/hidden depending on the value
        const value = valueAccessor();
        $(element).toggle(ko.utils.unwrapObservable(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
    },
    update: function (element) {
        $(element).hide().fadeIn(400);
    }
});
